import React from 'react';
import { Row, CellContainer } from '@bit/knotchinc.web-react-components.table-sync';
import {
  StyledContentTitle,
  StyledEntityTitle,
  ContentContainer,
  ValueContainer,
  Value,
  ValueDesc,
} from 'components/Pages/Reports/EntityOverview/styled.js';
import {
  ErrorWrapper,
  EmptyEntityTitleBar,
  ErrorText,
  ErrorEmptyTagContainer,
  ErrorEmptyTag,
  EmptyContentTypeIcon,
  EmptyEntityIcon,
} from './styled.js';

/* Note: IE9 doesn't support Array.from, so I'm manually declaring this array */
const errorResources = [
  { value: 'No content found' },
  { value: 'No content found' },
  { value: 'No content found' },
  { value: 'No content found' },
  { value: 'No content found' },
];

export const ErrorStatsOverviewRow = ({ type, entityType }) => (
  <ErrorWrapper>
    {errorResources.map(({ value }, idx) => (
      <Row height="68" key={`error-share-row-${idx}`}>
        <CellContainer width={0.4}>
          { type === 'entity' ? (
            <ContentContainer>
              <EmptyEntityIcon />
              <StyledContentTitle>
                <ErrorText>{entityType === 'brand' ? 'Publisher' : 'Brand'}</ErrorText>
              </StyledContentTitle>
            </ContentContainer>
          ) : (
            <ContentContainer>
              <StyledContentTitle>
                <ErrorText>{value}</ErrorText>
              </StyledContentTitle>
              <StyledEntityTitle>
                <EmptyContentTypeIcon />
                <EmptyEntityTitleBar width="159px" />
              </StyledEntityTitle>
            </ContentContainer>
          )}
        </CellContainer>
        <CellContainer width={0.5}>
          <ErrorEmptyTagContainer>
            <ErrorEmptyTag />
            <ErrorEmptyTag />
            <ErrorEmptyTag />
            { type === 'entity' ? (
              <React.Fragment>
                <ErrorEmptyTag />
                <ErrorEmptyTag />
              </React.Fragment>
            ) : null}
          </ErrorEmptyTagContainer>
        </CellContainer>
        <CellContainer width={0.1}>
          <ValueContainer>
            <Value>--</Value>
            <ValueDesc>Shares</ValueDesc>
          </ValueContainer>
        </CellContainer>
      </Row>
    ))}
  </ErrorWrapper>
);

export default ErrorStatsOverviewRow;
